export const projects = [
  {
    name: 'MovieDB',
    youtubeUrl: 'https://www.youtube.com/embed/UZjqvVMOtVI',
    youtubeId: 'UZjqvVMOtVI',
    id: 1,
    gitHub: 'https://github.com/VitTheDev/movieDb',
    description: `Whether you're looking to kill some time watching a movie, or you want to stay relevant in coffeehouse conversations, this app will help you achieve that. Browse by category or search for a specific title.`,
    tools: [
      'React',
      'Redux',
      'CSS - Modules',
      'Thunk',
      'Axios',
      'Enzyme',
      'Jest',
      'React-router-DOM',
      'React-Resize-Detector',
    ],
  },
  {
    name: 'Meal-finder',
    youtubeUrl: 'https://www.youtube.com/embed/HpLBeh0lZO8',
    youtubeId: 'HpLBeh0lZO8',
    id: 2,
    gitHub: 'https://github.com/VitTheDev/Meal-finder',
    description: `This app is the perfect solution if you're loking for recipe ideas. And if you don't know what to cook, just hit the random button and see what happens.`,
    tools: ['JavaScript', 'HTML5', 'CSS Grid', 'Async - Fetch()'],
  },
  {
    name: 'Portfolio',
    youtubeUrl: 'https://www.youtube.com/embed/LA-G_ugEz9M',
    youtubeId: 'LA-G_ugEz9M',
    id: 3,
    gitHub: 'https://github.com/VitTheDev/reactPortfolio',
    description: `Instead of going with a pre-defined templated website, I decided to create my portfolio as a React app from scratch.`,
    tools: ['React', 'Hooks', 'Sass', 'Axios', 'Enzyme', 'CSS - Animation'],
  },
  {
    name: 'Lyric Finder',
    id: 4,
    youtubeUrl: 'https://www.youtube.com/embed/mIWxwWIAVzU',
    gitHub: 'https://github.com/VitTheDev/Lyric-finder',
    youtubeId: 'mIWxwWIAVzU',
    description: `Go find your favourite songs' lyrics. Because why not.`,
    tools: ['React', 'Bootstrap', 'Hooks', 'Context Api', 'Axios'],
  },
  {
    name: 'Mini-posts',
    id: 5,
    youtubeUrl: 'https://www.youtube.com/embed/LTa256oI0-0',
    gitHub: 'https://github.com/VitTheDev/Posting',
    youtubeId: 'LTa256oI0-0',
    description: `If you need to save some thoughts of yours into your digital bes friend, this app has you covered. Although it's mainly a CRUD practice :)`,
    tools: [
      'JavaScript',
      'CSS3',
      'OOP',
      'CRUD',
      'JSON-Server',
      'Webpack',
      'Babel',
      'Axios',
    ],
  },
  {
    name: 'Switch All the Lights Off',
    id: 6,
    youtubeUrl: 'https://www.youtube.com/embed/HpLBeh0lZO8',
    gitHub: 'https://github.com/VitTheDev/SwitchAllTheLightsOff',
    youtubeId: 'd5E13WsEW1Q',
    description: `This is a fun game, as well as a brain teaser. Have fun.`,
    tools: ['React', 'CSS3'],
  },
  {
    name: 'Weather Apps',
    id: 7,
    youtubeUrl: 'https://www.youtube.com/embed/IfPrPsN5uGw',
    gitHub: 'https://github.com/VitTheDev/weather_react',
    youtubeId: 'IfPrPsN5uGw',
    description: `I actually included 2 apps in the video. One Uses React hooks and the other one uses redux and Reack Sparklines and outputs different data using charts.`,
    tools: [
      'React',
      'CSS3',
      'Sass',
      'Hooks',
      'Redux',
      'React-Sparklines',
      'Lodash',
    ],
  },
  {
    name: 'Budget-tracker',
    id: 8,
    youtubeUrl: 'https://www.youtube.com/embed/HpLBeh0lZO8',
    gitHub: 'https://github.com/VitTheDev/Budget-Tracker',
    youtubeId: 'H8tahVEILaY',
    description: `This simple vanilla JavaScript app is quite useful for someone like me, as I always seem to have less money in my wallet than I think.`,
    tools: ['JavaScript', 'CSS3'],
  },
  {
    name: 'Hangman Game',
    id: 9,
    youtubeUrl: 'https://www.youtube.com/embed/HMc3KoSY3JM',
    gitHub: 'https://github.com/VitTheDev/Hangman-game',
    youtubeId: 'HMc3KoSY3JM',
    description: `This is a fun game, I still remember playig it at school. Here you have it on the screen instead of a blackboard. Have fun.`,
    tools: ['React', 'CSS3'],
  },
];

export const key = 'AIzaSyD5M9UuOWJIKvsMffs1r2Af7FQO_7D186s';
